import { useStaticQuery, graphql } from 'gatsby'

const useAuthorsEn = () => {
  const { authors } = useStaticQuery(
    graphql`
      query AuthorsEn {
        authors: allMarkdownRemark(
          filter: {
            fields: { language: { eq: "en" }, type: { eq: "authors" } }
          }
          sort: { fields: [frontmatter___date], order: DESC }
        ) {
          edges {
            node {
              fields {
                language
              }
              frontmatter {
                id
                name
                position
                avatar {
                  childImageSharp {
                    fixed(width: 280) {
                      src
                      srcSet
                      srcSetWebp
                      width
                      height
                    }
                  }
                }
              }
            }
          }
        }
      }
    `
  )
  return authors
}

export { useAuthorsEn }
